import ComponentBase from 'components/_base/ComponentBase';
import jQuery from 'jquery';

/**
 * @class ToggleBtn
 * @memberof core.components
 * 
 * @fires Widget#TOGGLE_PANEL_MENU
 * @fires Widget#TOGGLE_MAIN_MENU
 * @fires Widget#TOGGLE_DRAW_TOOL
 */
const ToggleBtn = ComponentBase.extend(
  /**
   * @lends core.components.ToggleBtn.prototype
   */
  {

    template: require('./toggleBtn.hbs'),

    events: {
      'click': 'toggleBtn'
    },

    /**
     * Initialize the component
     * @function
     * @param {Object} options - The config provided by json
     */
    initialize(config) {
      this.bus = this.widget.bus;
      ComponentBase.prototype.initialize.call(this, config);
    },

    /**
     * Fires the event and toggle class
     * @private
     */
    toggleBtn(event) {
      this.bus.trigger(this.properties.event, this);
      jQuery(this.el).toggleClass('lmm-active');
    }
  });

export default ToggleBtn;



// WEBPACK FOOTER //
// ./lmm-widget/src/components/toggleBtn/ToggleBtn.js